import { render, staticRenderFns } from "./GKProgressBar.vue?vue&type=template&id=31453faa&scoped=true&"
import script from "./GKProgressBar.vue?vue&type=script&lang=js&"
export * from "./GKProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./GKProgressBar.vue?vue&type=style&index=0&id=31453faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31453faa",
  null
  
)

export default component.exports